import { render, staticRenderFns } from "./Lab.vue?vue&type=template&id=42726a8e&scoped=true&"
import script from "./Lab.vue?vue&type=script&lang=js&"
export * from "./Lab.vue?vue&type=script&lang=js&"
import style0 from "./Lab.vue?vue&type=style&index=0&id=42726a8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42726a8e",
  null
  
)

export default component.exports